import { createContext } from 'react';

/**
 * This file is a context that we can pass from the top of scheduling to its children
 * In order to cleanly pass references.
 * @type {React.Context<unknown>}
 */
const SchedulingContext = createContext();

export default SchedulingContext;
